export default __webpack_public_path__ + "static/media/rewards.17f75c52.svg";